// Always include common JS to page-specific
import '/js/common/index';

import { setMetrikaGoal } from '../common/functions';
import {
    initButtons,
    initIndexSlider,
    initSubscribeEmailForm,
    initSubscribeEmailHandler,
    initTodayOnly
} from './functions';
import {initPicturesWithPinsSlider} from "../pictures-with-pins";

$(document).ready(() => {
    initButtons();
    initIndexSlider();
    initTodayOnly();
    initSubscribeEmailForm();
    initSubscribeEmailHandler();
    initPicturesWithPinsSlider();

    // Ya.Metrika counter events
    $(document).on('click', '.big-sale .col-xs-6', function() {
        setMetrikaGoal('MSPOP' + $(this).index());
    });
    $(document).on('click', '#wrapper.index .footer a', function() {
        setMetrikaGoal('MSFOOTER');
    });
});